import React from "react";
import { Box, Typography } from "@material-ui/core";
import useCheckoutClassicStyles from "./checkoutClassicStyles";

// Green-accents any "Nx" growth token (e.g. "5x", "10x"), mirroring the
// reference hero which colors "5x". Only the token is wrapped; the rest of the
// headline keeps the default color. Matches whole tokens so "24x7" is left be.
function highlightAccent(text) {
  const str = String(text || "");
  return str.split(/(\b\d+[xX]\b)/g).map((part, i) =>
    /^\d+[xX]$/.test(part) ? (
      <span key={i} style={{ color: "#04cf66" }}>
        {part}
      </span>
    ) : (
      part
    )
  );
}

export default function CheckoutHero({ logo, cob, title }) {
  const classes = useCheckoutClassicStyles();
  return (
    <>
      <Box className={classes.headerLogo}>
        <img className={classes.logo} src={logo} alt="AiSensy" />
        {cob && cob.enabled && (
          <>
            <span className={classes.partnerSeparator}>×</span>
            {cob.partnerLogoUrl ? (
              <img
                className={classes.partnerLogo}
                src={cob.partnerLogoUrl}
                alt={cob.partnerName || "Partner"}
              />
            ) : (
              <span style={{ fontSize: 14, color: "#666" }}>
                {cob.partnerName || "Partner"}
              </span>
            )}
          </>
        )}
      </Box>
      {cob && cob.enabled && cob.partnerName && (
        <Box className={classes.partnershipBadge}>
          <Typography variant="caption" className={classes.badgeText}>
            In Partnership with {cob.partnerName}
          </Typography>
        </Box>
      )}
      <Typography variant="h4" className={classes.heroTitle}>
        {highlightAccent(title)}
      </Typography>
    </>
  );
}
